// Connectivity as a plain boolean for templates and guards. The state itself lives in
// useConnectivity(), which derives it from real request outcomes rather than navigator.onLine.
export const useOnline = () => {
  const { isOnline } = useConnectivity();
  return computed(() => isOnline.value);
};
